import type { CollectionResponse, Stream, WebsocketMessage } from '~/types'

export const useStreamApi = () => {
  /**
   * List of all running streams with the latest message
   */
  const search = async () => {
    return useApiGet<CollectionResponse<Stream.Model>>('/streams/')
  }

  /**
   * List of all messages for requested stream
   */
  const messages = async (streamId: string) => {
    return useApiGet<CollectionResponse<WebsocketMessage.Model>>(`/streams/${streamId}/messages/`)
  }

  return { search, messages }
}
